import React from "react";
import MasterModal from "./MasterModal";
import { i18n } from "../../translate/i18n";

export default function MasterConfirmationModal({
	title,
	children,
	open,
	onClose,
	onConfirm,
}) {
	const handleClose = () => onClose(false);

	return (
		<MasterModal
			open={open}
			onClose={handleClose}
			title={title}
			maxWidth={480}
			footer={
				<>
					<button type="button" className="btn-secondary" onClick={handleClose}>
						{i18n.t("confirmationModal.buttons.cancel")}
					</button>
					<button
						type="button"
						className="btn-primary"
						onClick={() => {
							handleClose();
							onConfirm();
						}}
					>
						{i18n.t("confirmationModal.buttons.confirm")}
					</button>
				</>
			}
		>
			<p className="m-0 text-sm leading-6 text-default-700 dark:text-default-200">
				{children}
			</p>
		</MasterModal>
	);
}
